import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import About from './About';
import CompanyDashboard from './CompanyDashboard';
import EditForm from './EditForm';
import Header from './Header';
import Landing from './Landing';
import Login from './Login';
import MyAccount from './MyAccount';
import Profile from './Profile';
import Register from './Register';
import Table from './Table';
import Training from './Training';
import User from './User';
const levelAcces = ()=>{
    var localLevelAcces = 0;
    var isAdmin = false;
    var isUniAdmin = false;
    var isCompany = false;
    // admin
    for(var grantedAuthority of User.authorities){
        if (grantedAuthority.authority === "ROLE_ADMIN"){
            isAdmin = true;
            localLevelAcces = 3;
            break;
        } else if (grantedAuthority.authority === "ROLE_UNIVERSITY"){
            isUniAdmin =true;
            localLevelAcces = 2;
        } else if (grantedAuthority.authority === "ROLE_COMPANY"){
            isCompany = true;
            if(localLevelAcces<1){
                localLevelAcces = 1;
            }
        }
    }
    return localLevelAcces;
    // university admin
  
    // company
}

const App = () => {


    const [loading,setLoading] = useState(true);

    useEffect(()=>{
        async function wait1s(){
            while(User.isLoading){
                await new Promise(resolve => setTimeout(resolve, 2));
            }
            setLoading(false);
        }
        wait1s()
    },[]);
 
    return (
        <div className="">
            <BrowserRouter>
                {/* <Header/> */}
                <Route path="/" exact component={Landing}/>
                <Route path="/login" exact component={Login}/>
                <Route path="/companies" exact component={Table}/>
                <Route path="/about" exact component={About}/>
                <Route path="/training" exact component={Training}/>
                {levelAcces()>=2?<Route path="/dashboard" exact component={CompanyDashboard}/> : ''}
                {levelAcces()>=1?<Route path="/companies/:id/edit" exact component={EditForm} /> : ''}
                {levelAcces()>=1?<Route path="/myaccount" exact component={MyAccount} /> : ''}
                <Route path="/companies/:id" exact component={Profile} />
                <Route path="/register/:token" exact component={Register} />
            </BrowserRouter>
        </div>
    );
};

export default App;